export default __webpack_public_path__ + "locales/ro/ChangePasswordDialog.json?hash=119e4c641639782d3cb73a318f174f63";